<template>
  <sliding-window>
    <div slot="panel">
      <h3>Fiches récapitulatives</h3>
      <hr />
      <div class="field">
        <div class="control">
          <button
            class="button"
            @click="print"
            :class="loading ? 'is-loading' : ''"
          >
            <i class="fa fa-print"></i>&nbsp;imprimer (serveur)
          </button>
          &nbsp;
          <button class="button" @click="printManual">
            <i class="fa fa-print"></i>&nbsp;imprimer (manuel)
          </button>
        </div>
      </div>
      <hr />
      <div class="control" v-if="render">
        <div class="RenderPreview">
          <img class="RenderPreview__img" :src="render.thumbnail.public_path" />
        </div>
        <a class="button is-info" :href="render.friendly_path" target="_blank"
          >Télécharger</a
        >
      </div>
      <hr />
      <div class="control">
        <router-link :to="'/home'"
          ><i class="fa fa-arrow-left"></i> accueil</router-link
        >
      </div>
    </div>
    <page-format-handler :format="'A4'">
      <page v-for="p in projects" :key="p.uuid">
        <page-inner style="color: #31287c">
          <div class="ScESummary">
            <div class="columns">
              <div class="column is-one-fifth">
                <api-picture
                  :picture-id="p.main_image"
                  :lazy="false"
                ></api-picture>
              </div>
              <div class="column is-four-fifths">
                <h2>{{ p.code }} {{ p.name }}</h2>
                <h3>
                  {{ p.address }}, {{ p.zipcode }} {{ p.city }}, {{ p.country
                  }}<br />{{ p.lat }}°N, {{ p.lng }}°E
                </h3>
              </div>
            </div>
            <div class="columns">
              <div class="column is-two-fifths">
                <ul>
                  <li>
                    Coût :
                    <span v-if="p.cost">{{ formatNumbers(p.cost) }}€</span>
                  </li>
                  <li
                    v-for="s in p.surfaces_d.filter(a => a.content)"
                    :key="s.surface_id"
                  >
                    {{ s.text }} : <span>{{ formatNumbers(s.content) }}m²</span>
                  </li>
                  <ul>
                    <li v-for="(d, index) in p.dates_d" :key="index">
                      {{ d.text }} : {{ formatDateFrench(d.content) }}
                    </li>
                  </ul>
                </ul>
              </div>
              <div class="column is-three-fifths">
                <ul>
                  <li v-if="p.typologies.length > 0">
                    Typologies : {{ mapNames(p.typologies) }}
                  </li>
                  <li v-if="p.programs.length > 0">
                    Programme : {{ mapNames(p.programs) }}
                  </li>
                  <li>Programme scalene : {{ p.program_scalene }}</li>
                  <li v-if="p.procedures.length > 0">
                    Procédure : {{ mapNames(p.procedures) }}
                  </li>
                  <li v-if="p.missions.length > 0">
                    Mission : {{ mapNames(p.missions) }}
                  </li>
                  <li v-if="p.awards.length > 0">
                    Récompenses : {{ mapNames(p.awards) }}
                  </li>
                  <li v-if="p.labels.length > 0">
                    Labels : {{ mapNames(p.labels) }}
                  </li>
                  <li v-if="p.normes.length > 0">
                    Normes: {{ mapNames(p.normes) }}
                  </li>
                </ul>
              </div>
            </div>
            <table style="color:#31287c;">
              <tr
                v-for="(axe, index) in p.contents_d"
                :key="index"
                style="border-bottom: 1px solid #31287c55"
              >
                <td style="width: 20%; padding-bottom:4px; padding-top: 4px;">
                  <api-picture
                    v-if="axe.pictures.length > 0 && axe.pictures[0].picture"
                    :picture-id="axe.pictures[0].picture.id"
                    :lazy="false"
                  ></api-picture>
                </td>
                <td
                  style="padding-left: 8px; padding-bottom:4px; padding-top: 4px;"
                >
                  <p>{{ axe.name }}<br />{{ axe.text }}</p>
                </td>
              </tr>
            </table>
          </div>
        </page-inner>
      </page>
    </page-format-handler>
  </sliding-window>
</template>

<script>
import SlidingWindow from "../PrintComponents/Workspace/SlidingWindow";
import { types as t } from "../../../store/actions/projects";
import { get, rem } from "../../../storage/storage";
import { types } from "../../../store/actions/render";
import PageFormatHandler from "../PrintComponents/Page/PageFormatHandler";
import PageInner from "../PrintComponents/Page/PageInner";
import Page from "../PrintComponents/Page/Page";
import { formatNumbers, mapNames, formatDateFrench } from "../../../util/func";
import ApiPicture from "../../../components/Form/ApiPicture";

export default {
  name: "Index",
  components: {
    ApiPicture,
    Page,
    PageInner,
    SlidingWindow,
    PageFormatHandler
  },
  data() {
    return {
      projects: [],
      sortedProjects: [],
      loading: false,
      render: null,
      pm: {
        format: "A4"
      }
    };
  },
  props: {
    ids: {}
  },
  computed: {
    pagesLength() {
      return this.projects.length;
    }
  },
  methods: {
    formatNumbers,
    mapNames,
    formatDateFrench,
    sortProjects() {
      return this.projects;
    },
    printManual() {
      this.$store.commit("setDrawingRatio", 1);
      setTimeout(() => {
        window.print();
      }, 300);
    },
    async print() {
      this.loading = true;
      await new Promise(r => setTimeout(r, 500));
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        range: `1-${this.pagesLength}`,
        timeout: 2000 + this.pagesLength * 100,
        friendly_name: `${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}-summary${
          this.title ? "-" + this.title : ""
        }.pdf`.replace(/(\s|\/|:)/gi, "-")
      });
      this.render = render;
      this.loading = false;
    }
  },
  async mounted() {
    if (window.HEADLESS) {
      this.$store
        .dispatch(types.GET_RENDERING_PAYLOAD, get("payload"))
        .then(d => {
          for (let prop in d) {
            this.$set(this, prop, d[prop]);
          }
          rem("payload");
        });
    } else {
      this.projects = await this.$store.dispatch(
        t.GET_PROJECTS_BY_IDS_D,
        this.ids
      );
      this.sortedProjects = this.projects;
      rem("payload");
    }
  }
};
</script>

<style lang="scss">
.ScESummary {
  font-size: 11px;
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 14px;
  }
}
</style>
